import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { standardizedTestsContent } from '../content';

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introductory section explaining the role of standardized tests (ACT, SAT, AP, IB) in college admissions and placement.',
    detail: [
      standardizedTestsContent.header.description.join('\n'),
      'Discussion questions:',
      ...standardizedTestsContent.discussionQuestions.questions,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: standardizedTestsContent.whyScoresMatter.title,
    description:
      'Explains the broader value of test scores beyond admissions, including scholarships, placement, program eligibility, and self-knowledge.',
    detail: [
      standardizedTestsContent.whyScoresMatter.intro,
      ...standardizedTestsContent.whyScoresMatter.items.map(
        (item) => `${item.label}: ${item.description}`,
      ),
      standardizedTestsContent.whyScoresMatter.conclusion,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: standardizedTestsContent.tools.title,
    description: 'Backrs tools to support test preparation planning.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: standardizedTestsContent.corePrinciples.title,
    description: 'Six core principles for a strategic testing plan.',
    detail: standardizedTestsContent.corePrinciples.principles
      .map((p) => `${p.number}. ${p.title}: ${p.body}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: standardizedTestsContent.mythsAndMistakes.title,
    description:
      'Common myths and mistakes about standardized testing, covering test-optional policies, retakes, free resources, and timing.',
    detail: [
      standardizedTestsContent.mythsAndMistakes.intro,
      ...standardizedTestsContent.mythsAndMistakes.items.map(
        (item) => `${item.type === 'myth' ? 'Myth' : 'Mistake'}: ${item.title} — ${item.body}`,
      ),
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: standardizedTestsContent.strategyByGoal.title,
    description:
      'Tailored testing strategies for different student paths: college admissions, AP/IB, scholarships, and CTE.',
    detail: standardizedTestsContent.strategyByGoal.strategies
      .map((s) => `${s.title}: ${s.points.join('; ')}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: standardizedTestsContent.multiYearFramework.title,
    description:
      'A multi-year testing timeline covering 9th–10th grade foundations, 11th grade primary testing, and 12th grade refinement.',
    detail: standardizedTestsContent.multiYearFramework.phases
      .map((p) => `${p.title}: ${p.points.join('; ')}`)
      .join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: standardizedTestsContent.faq.title,
    description:
      'Frequently asked questions about standardized testing including test choice, prep timing, and score submission.',
    detail: standardizedTestsContent.faq.questions
      .map((q) => `Q: ${q.question} A: ${q.answer}`)
      .join('\n'),
  });
};
